<button *ngIf="!link?.length" type="button"  matTooltip="{{label}}"
        class="rounded-full inline-flex justify-center items-center"
        attr.aria-label="{{label}}"
        [ngClass]="{'primary': typ==='PRIMARY', 'basic': typ==='BASIC', 'secondary': typ==='SECONDARY',
        'black': typ==='BLACK'
        }"
>
  <mat-icon class="okragly-przycisk-ikona" [svgIcon]="ikona"></mat-icon>
</button>
<a *ngIf="link && !href" [routerLink]="[link,linkParams]" matTooltip="{{label}}" attr.aria-label="{{label}}"
   class="rounded-full inline-flex justify-center items-center"
   [ngClass]="{'primary': typ==='PRIMARY', 'basic': typ==='BASIC', 'secondary': typ==='SECONDARY', 'black': typ==='BLACK' }"
>
  <mat-icon class="okragly-przycisk-ikona" [svgIcon]="ikona"></mat-icon>
</a>
<a *ngIf="href" target="_blank" href="{{href}}" matTooltip="{{label}}" attr.aria-label="{{label}}"
   class="rounded-full inline-flex justify-center items-center"
   [ngClass]="{'primary': typ==='PRIMARY', 'basic': typ==='BASIC', 'secondary': typ==='SECONDARY', 'black': typ==='BLACK' }"
>
  <mat-icon class="okragly-przycisk-ikona" [svgIcon]="ikona"></mat-icon>
</a>
